import React from 'react';
// Per-component paths: the package entry loads all ~100 of reactstrap's modules into every test file that
// renders Help (most of portal's), for these two.
import Popover from 'reactstrap/lib/Popover';
import PopoverBody from 'reactstrap/lib/PopoverBody';

const Help = ({ id, className, before, onClick, target, children, width }) => {
	const [open, setOpen] = React.useState(false);
	return (
		<span data-testid="popover-help">
			{target ? (
				<span
					id={id}
					data-testid={id}
					className={`pointer ${className}`}
					onMouseOver={() => setOpen(true)}
					onMouseOut={() => setOpen(false)}
					onTouchStart={() => setOpen(true)}
					onTouchEnd={() => setOpen(false)}
					onClick={onClick ? () => onClick() : null}
				>
					{target}
				</span>
			) : (
				<i
					id={id}
					data-testid={id}
					className={`fa fa-info-circle m${before ? 'r' : 'l'}10 pointer ${className}`}
					onMouseOver={() => setOpen(true)}
					onMouseOut={() => setOpen(false)}
					onTouchStart={() => setOpen(true)}
					onTouchEnd={() => setOpen(false)}
					onClick={onClick ? () => onClick() : null}
				/>
			)}
			<Popover isOpen={open} target={id} position="right">
				<PopoverBody className="popover-body copy">
					<div data-testid="popover-help-body" style={{ maxHeight: `${window.innerHeight}px` }}>
						{children}
					</div>
				</PopoverBody>
			</Popover>
		</span>
	);
};

export default Help;
